export default {
  username: {
    required: true,
    minLength: 0,
    validateOnBlur: false,
  },
  password: {
    required: true,
    minLength: 0,
    validateOnBlur: false,
  },
};
